module.exports = "../../static/img/7.Icon／suggested／6.minus-circle／fill.d213880.svg";